import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { injectIntl, intlShape } from 'react-intl';
import moment from 'moment';
import { map, times, update, addIndex, isNil, not, is, defaultTo } from 'ramda';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { edit, view } from './PartialDate.less';

/*
  Partial date component is used to handle date input with only year or year and a month.
  Use calendar for taking dd-mm-yyyy input.

  Partial date values are in an array [ yyyy, mm, NULL ]
  TODO: Move logic to a separate container, rewrite
*/

/*
  Map the elements before
 */
const currentYear = moment().year();

const yearElements = times(n => {
  const y = currentYear - n;
  return <MenuItem key={`year__${y}`} value={y} primaryText={y} />;
}, 60);

const monthElements = addIndex(map)((m, i) => <MenuItem key={m} value={i} primaryText={m} />, moment.months());

// TODO: There's probably a more elegant way
const defaultVal = val => {
  if (isNil(val)) return val;
  if (!Array.isArray(val)) return [null, null, null];

  const [a = null, b = null, c = null] = val;
  return [a, b, c];
};

const makeHandler = (input, idx) => (e, i, v) => {
  input.onChange(update(idx, v, defaultVal(input.value)));
};

const Edit = ({ input, precision, noFutureDates, formatMessage }) => (
  <Row className={edit}>
    <Col xs={5}>
      <SelectField
        value={defaultVal(input.value)[0]}
        onChange={makeHandler(input, 0)}
        hintText={formatMessage({ id: 'partialdate.insertYear' })}
      >
        {yearElements}
      </SelectField>
    </Col>
    {precision > 1 && (
      <Col xs={6}>
        <SelectField
          value={defaultVal(input.value)[1]}
          onChange={makeHandler(input, 1)}
          disabled={isNil(defaultVal(input.value)[0])}
          hintText={formatMessage({ id: 'partialdate.insertMonth' })}
        >
          {monthElements}
        </SelectField>
      </Col>
    )}
  </Row>
);

const getMonth = val => moment.months()[val];

const View = ({ input, precision, noFutureDates }) => (
  <div className={view}>
    {(precision <= 1 || not(is(Number, input.value[1]))) && defaultTo('', input.value[0])}
    {precision >= 2 &&
      is(Number, input.value[0]) &&
      is(Number, input.value[1]) &&
      `${getMonth(input.value[1])}, ${input.value[0]}`}
  </div>
);

const PartialDate = ({ editing, intl: { formatMessage }, noFutureDates = true, ...other }) =>
  editing ? (
    <Edit formatMessage={formatMessage} noFutureDates={noFutureDates} {...other} />
  ) : (
    <View noFutureDates={noFutureDates} {...other} />
  );

View.propTypes = {
  input: PropTypes.object,
  precision: PropTypes.number,
  noFutureDates: PropTypes.bool,
};

Edit.propTypes = {
  ...View.propTypes,
  formatMessage: PropTypes.func.isRequired,
};

PartialDate.propTypes = {
  editing: PropTypes.bool,
  noFutureDates: PropTypes.bool,
  intl: intlShape,
};

export default injectIntl(PartialDate);
